import attach from '@grantstreet/cart-ui/src/main-parent-wrapper.ts'

export default { attach }
